import { STATE_CRITERIA } from './stateCriteria';
import { formatOverall, parseDomainStat } from './formatCriteria';

export type ReclassDomainMinimum = { domain: string; value: number };

export type ReclassCriteria = {
  state: string;
  assessment: string;
  numeric: boolean;
  compositeMin: number | null;
  domainMinimum: ReclassDomainMinimum | null;
  overallLabel: string;
};

function isNumericScore(score: string): boolean {
  return /^\d+(\.\d+)?$/.test(score);
}

function parseDomainMinimum(domainSpecific?: string): ReclassDomainMinimum | null {
  if (!domainSpecific) return null;
  const simple = parseDomainStat(domainSpecific);
  if (simple) return { domain: simple.label, value: Number(simple.value) };
  const parenthesized = domainSpecific.match(/Minimum\s+(\d+(?:\.\d+)?)\s+in\b[^(]*\(([^)]+)\)/i);
  if (parenthesized && parenthesized[1] && parenthesized[2]) {
    return { domain: parenthesized[2].trim(), value: Number(parenthesized[1]) };
  }
  return null;
}

export function getReclassificationCriteria(state: string): ReclassCriteria | null {
  const criteria = STATE_CRITERIA.find((c) => c.state === state);
  if (!criteria) return null;

  const numeric = isNumericScore(criteria.overallScore);

  return {
    state: criteria.state,
    assessment: criteria.assessment,
    numeric,
    compositeMin: numeric ? Number(criteria.overallScore) : null,
    domainMinimum: parseDomainMinimum(criteria.domainSpecific),
    overallLabel: numeric ? formatOverall(criteria.overallScore) : criteria.overallScore,
  };
}
